import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './GuiaSearch.css';

function GuiaSearch({ tableData }) {
    return (
        <div className="guia_search-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No se encontraron resultados para esa búsqueda</h4>
            )}
        </div>
    );
}

export default GuiaSearch;
